export { default as LoyaltyNotificationsWidget } from './loyalty-notifications-widget';
